            (function(){
              if (window.__ffQaBound) return;
              window.__ffQaBound = true;

              var ffQaReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

              function ffQaRoot(el) { return el.closest('[data-ff-qa-root]'); }

              /* FF FIX BATCH 2026-08-12 (item 3): the panel is a popover now — the
                 card wrapper gets .ff-qa-open while it's up so template-collection.css
                 can raise the whole card above its neighbours (each grid item is its
                 own stacking context, so z-index on the panel alone is not enough). */
              function ffQaClosePanel(panel, toggleBtn) {
                panel.hidden = true;
                if (toggleBtn) { toggleBtn.setAttribute('aria-expanded', 'false'); }
                var wrap = panel.closest('.card-wrapper');
                if (wrap) { wrap.classList.remove('ff-qa-open'); }
              }
              function ffQaOpenPanel(panel, toggleBtn) {
                /* only one popover at a time */
                var others = document.querySelectorAll('[data-ff-qa-panel]:not([hidden])');
                for (var i = 0; i < others.length; i++) {
                  if (others[i] !== panel) {
                    var oRoot = ffQaRoot(others[i]);
                    ffQaClosePanel(others[i], oRoot && oRoot.querySelector('[data-ff-qa-toggle]'));
                  }
                }
                panel.hidden = false;
                if (toggleBtn) { toggleBtn.setAttribute('aria-expanded', 'true'); }
                var wrap = panel.closest('.card-wrapper');
                if (wrap) { wrap.classList.add('ff-qa-open'); }
              }

              function ffQaVariants(root) {
                var script = root.querySelector('script[data-ff-qa-variants]');
                if (!script) { return []; }
                try { return JSON.parse(script.textContent); } catch (e) { return []; }
              }

              function ffQaSelections(root) {
                var sel = {};
                var groups = root.querySelectorAll('[data-ff-qa-group]');
                for (var i = 0; i < groups.length; i++) {
                  /* FF WAVE 4: attribute selector, not '.ff-qa-pill' — the redesigned
                     configuration ROWS carry data-ff-qa-pill but not the pill class. */
                  var picked = groups[i].querySelector('[data-ff-qa-pill].is-selected');
                  sel[groups[i].getAttribute('data-option-index')] = picked ? picked.getAttribute('data-value') : null;
                }
                return sel;
              }

              function ffQaMatchVariant(root) {
                var variants = ffQaVariants(root);
                var sel = ffQaSelections(root);
                var groupCount = root.querySelectorAll('[data-ff-qa-group]').length;
                var selectedCount = 0;
                for (var k in sel) { if (sel[k]) { selectedCount++; } }
                if (selectedCount < groupCount || groupCount === 0) { return null; }
                for (var i = 0; i < variants.length; i++) {
                  var v = variants[i];
                  var ok = true;
                  for (var idx in sel) {
                    if (v.options[idx] !== sel[idx]) { ok = false; break; }
                  }
                  if (ok) { return v; }
                }
                return null;
              }

              function ffQaFormatMoney(cents) {
                return '$' + Math.round(cents / 100).toLocaleString();
              }

              /* FF WAVE 7 (2026-08-13, item 1 fix — "Liberty dark grey" white/blank
                 tile bug): shared helpers for any JS-driven image swap on a card
                 (popover selection here, and the C+ dot hover-swap below).

                 ROOT CAUSE (confirmed by rendering, not guessed): swapping the
                 <img> src never touched its fit CLASS. On the sectional-sofas
                 lifestyle pilot (.ff-card-lifestyle) the default image is a
                 full-bleed room photo, page-rendered with .ff-card-fit-cover
                 (object-fit:cover, object-position:60%) — correct for THAT photo.
                 But an individual VARIANT's featured_image is frequently a
                 transparent-background product cutout (e.g.
                 "*_card_transparent_*.png", ~1080x1080 with the product occupying
                 well under half the canvas). Swapping src to that cutout while
                 leaving the old cover-fit class in place crops/zooms the frame
                 into the image — for the reported repro (Liberty U-Shaped Sleeper
                 Sectional, "Charcoal") the crop box measured 56% transparent
                 pixels, i.e. a mostly blank white tile, confirmed by re-rendering
                 the actual cutout at the card's real frame aspect + 60% position.
                 Fix: any JS swap now forces a safe contain-on-white fit
                 (.ff-qa-img-swapped, template-collection.css) instead of
                 inheriting a fit class computed for a different photo. Also: if
                 no qualifying variant image is found at all (data gap, or an
                 unavailable option combo), the tile now reverts to the product's
                 own original card image instead of being left however a PRIOR
                 partial selection happened to leave it. */
              function ffQaCaptureOriginalImage(img) {
                if (!img.dataset.ffQaOrigCaptured) {
                  img.dataset.ffQaOrigSrc = img.getAttribute('src') || '';
                  img.dataset.ffQaOrigSrcset = img.getAttribute('srcset') || '';
                  img.dataset.ffQaOrigClass = img.className;
                  img.dataset.ffQaOrigCaptured = '1';
                }
              }

              function ffQaRestoreOriginalImage(img) {
                if (!img.dataset.ffQaOrigCaptured) { return; }
                if (img.dataset.ffQaOrigSrcset) {
                  img.setAttribute('srcset', img.dataset.ffQaOrigSrcset);
                } else {
                  img.removeAttribute('srcset');
                }
                img.setAttribute('src', img.dataset.ffQaOrigSrc);
                img.className = img.dataset.ffQaOrigClass;
              }

              function ffQaApplySwappedImage(img, url, isLifestyle) {
                img.removeAttribute('srcset');
                img.setAttribute('src', url);
                // wip272: also drop the low-table anchor modifier. Functionally this is
                // already safe without the line (the .ff-card-anchor-lowtable rule only
                // matches when .ff-card-fit-cover is ALSO present, and that class is
                // removed on the line above), but leaving a stale modifier on the tag
                // would be a trap for the next reader. ffQaRestoreOriginalImage restores
                // the whole original className string, so the modifier comes back intact.
                img.classList.remove('ff-card-fit-cover', 'ff-card-fit-contain', 'ff-card-anchor-lowtable');
                /* FF WIP334 (2026-08-17): two possible swap fits now. A curated lifestyle
                   room photo (ffwip.variant_lifestyle) is a full-bleed photograph like any
                   other card lifestyle image, so it gets the same cover/60% treatment
                   (.ff-qa-img-swapped-life). Anything else (raw variant featured_image) may
                   be a transparent cutout, so it keeps the existing safe contain-on-white
                   fit (.ff-qa-img-swapped, WAVE 7 white-tile fix) -- unchanged default when
                   isLifestyle is omitted, so the C+ dot hover-swap below (which doesn't pass
                   this argument) keeps its prior behaviour exactly. */
                img.classList.remove('ff-qa-img-swapped', 'ff-qa-img-swapped-life');
                img.classList.add(isLifestyle ? 'ff-qa-img-swapped-life' : 'ff-qa-img-swapped');
              }

              function ffQaFindColorVariantImage(root, colorValue) {
                var variants = ffQaVariants(root);
                for (var i = 0; i < variants.length; i++) {
                  var v = variants[i];
                  if (v.options && v.options.indexOf(colorValue) !== -1 && v.image) {
                    return v.image;
                  }
                }
                return null;
              }

              /* FF WAVE 4 (2026-08-12, popover redesign item 3): generalizes wave-2's
                 colour-only image swap — the card image now follows ANY selection
                 (configuration rows included). First variant matching every
                 currently-selected option value that has its own image wins; partial
                 selections (e.g. config picked, colour not yet) still swap. */
              function ffQaUpdateImage(root) {
                var sel = ffQaSelections(root);
                var picked = {};
                var any = false;
                for (var k in sel) { if (sel[k]) { picked[k] = sel[k]; any = true; } }
                if (!any) { return; }
                var wrapper = root.closest('.card-wrapper');
                var img = wrapper && wrapper.querySelector('.card__media img');
                if (!img) { return; }
                ffQaCaptureOriginalImage(img);
                var variants = ffQaVariants(root);
                for (var i = 0; i < variants.length; i++) {
                  var v = variants[i];
                  var ok = true;
                  for (var k2 in picked) {
                    if (v.options[k2] !== picked[k2]) { ok = false; break; }
                  }
                  if (ok && v.image) {
                    ffQaApplySwappedImage(img, v.image, !!v.life);
                    return;
                  }
                }
                /* No variant matching the current selection has a usable image
                   (data gap, or a combo that isn't a real variant) — fall back to
                   the product's own default card image rather than leaving the
                   tile in whatever state a previous selection left it. */
                ffQaRestoreOriginalImage(img);
              }

              function ffQaUpdatePanelState(root) {
                var addBtn = root.querySelector('[data-ff-qa-panel] [data-ff-qa-add]');
                var priceEl = root.querySelector('[data-ff-qa-price]');
                var v = ffQaMatchVariant(root);
                if (addBtn) {
                  if (v && v.available) {
                    addBtn.disabled = false;
                    addBtn.setAttribute('data-variant-id', v.id);
                  } else {
                    addBtn.disabled = true;
                    addBtn.setAttribute('data-variant-id', '');
                  }
                }
                if (v && priceEl) { priceEl.textContent = ffQaFormatMoney(v.price); }
                ffQaUpdateImage(root);
              }

              function ffQaRefreshCartBadge() {
                var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
                fetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
                  .then(function (r) { return r.json(); })
                  .then(function (sections) {
                    var html = sections && sections['cart-icon-bubble'];
                    if (!html) { return; }
                    var doc = new DOMParser().parseFromString(html, 'text/html');
                    /* FF FIX (2026-08-11, wip66): the Section Rendering API wraps this
                       section's markup in <div id="shopify-section-cart-icon-bubble">
                       (Shopify's standard "shopify-section-<name>" wrapper id) -- it does
                       NOT contain a nested element with id="cart-icon-bubble" the way the
                       live theme's own <a id="cart-icon-bubble"> does, since the live markup
                       puts that id directly on the link rather than on a wrapper. The old
                       doc.getElementById('cart-icon-bubble') lookup therefore always
                       returned null against the fetched HTML, so the badge silently never
                       updated or popped on any successful quick-add. Read the wrapper by its
                       actual (relative) id instead and use ITS innerHTML -- that inner
                       content (icon svg + count bubble) is exactly what belongs inside the
                       live #cart-icon-bubble link. */
                    var fresh = doc.getElementById('shopify-section-cart-icon-bubble');
                    var live = document.getElementById('cart-icon-bubble');
                    if (fresh && live) {
                      live.innerHTML = fresh.innerHTML;
                      if (!ffQaReducedMotion) {
                        live.classList.add('ff-qa-badge-pop');
                        setTimeout(function () { live.classList.remove('ff-qa-badge-pop'); }, 500);
                      }
                    }
                  })
                  .catch(function () {});
              }

              function ffQaShowAdded(btn) {
                btn.classList.add('is-added');
                setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
              }

              /* FF WAVE 6 (2026-08-13, wip170 — owner REVERSED wave 4 again): the cart
                 drawer is the confirmation on EVERY successful add, collections and
                 search included. History: 2026-08-11 hero gate (drawer for heroes only)
                 -> 2026-08-12 wave 1 (drawer for every quick-add) -> 2026-08-12 wave 4
                 (toast only, no drawer) -> NOW (drawer everywhere again).
                 Mechanism, deliberately the wave-1 one so no shared file has to move:
                 /cart/add.js already asks for `sections: cart-drawer,cart-icon-bubble`,
                 so freshly-rendered drawer HTML arrives with the add response — we swap
                 it in and call the drawer element's own open(). Two independent backstops
                 keep the shopper from ever getting silence:
                   (a) window.__ffLastAddIsHero = TRUE + the cart:updated dispatch re-arm
                       cart-drawer.liquid's own safety-net listener, which force-opens the
                       drawer (with its own fresh fetch) ~350ms later if we didn't;
                   (b) ffQaConfirmAdd() checks at +1200ms and falls back to the toast if
                       the drawer still isn't `active`.
                 HERO PRODUCTS ARE UNAFFECTED: whether the drawer renders its hero or
                 non-hero body is decided in Liquid by `ff_is_hero_cart` (cart CONTENTS,
                 bliss/olivia/haven tags) inside cart-drawer.liquid — nothing here touches
                 that. __ffLastAddIsHero is (despite its 2026-08-11 name) only the
                 "should the drawer open" flag. snippets/cart-drawer.liquid and
                 snippets/custom-cart.liquid are NOT modified by this wave. */
              function ffQaSyncDrawer(sections) {
                try {
                  if (sections && sections['cart-drawer']) {
                    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                    var nw = doc.getElementById('CartDrawer');
                    var ol = document.getElementById('CartDrawer');
                    if (nw && ol) { ol.innerHTML = nw.innerHTML; }
                    var drawer = document.querySelector('cart-drawer');
                    if (drawer) {
                      drawer.classList.remove('is-empty');
                      var inner = drawer.querySelector('.drawer__inner');
                      if (inner) { inner.classList.remove('is-empty'); }
                    }
                    return true;
                  }
                } catch (e) { /* safety net below re-fetches a fresh drawer */ }
                return false;
              }
              /* Open the standard cart drawer through the theme's OWN mechanism — the
                 <cart-drawer> custom element's open() (assets/cart-drawer.min.js). The
                 class fallback is the exact pair cart-drawer.liquid's safety net uses
                 when open() is unavailable (element not yet upgraded). */
              function ffQaOpenDrawer() {
                try {
                  var drawer = document.querySelector('cart-drawer');
                  if (!drawer) { return false; }
                  if (drawer.classList.contains('active')) { return true; }
                  drawer.classList.remove('is-empty');
                  if (typeof drawer.open === 'function') { drawer.open(); }
                  else {
                    drawer.classList.add('active');
                    document.documentElement.classList.add('overflow-hidden');
                  }
                  return true;
                } catch (e) { return false; }
              }
              /* Never leave the shopper with no feedback: if neither our direct open nor
                 cart-drawer.liquid's 350ms safety net got the drawer on screen (drawer
                 element missing, JS error, slow /?sections= fetch), fall back to the
                 wave-4 toast rather than silence. */
              function ffQaConfirmAdd() {
                window.setTimeout(function () {
                  var drawer = document.querySelector('cart-drawer');
                  if (drawer && drawer.classList.contains('active')) { return; }
                  ffQaToast('Added to cart ✓');
                }, 1200);
                /* Disarm after the safety net's 350ms window: assets/cart.min.js fires
                   the same "cart:updated" event on quantity changes and removes (drawer
                   steppers, /cart page), and a stale `true` would let one of those
                   re-open a drawer the shopper had deliberately closed. */
                window.setTimeout(function () { window.__ffLastAddIsHero = false; }, 1500);
              }
              function ffQaSyncBadge(sections) {
                try {
                  if (sections && sections['cart-icon-bubble']) {
                    var live = document.getElementById('cart-icon-bubble');
                    var fresh = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').getElementById('shopify-section-cart-icon-bubble');
                    if (live && fresh) {
                      live.innerHTML = fresh.innerHTML;
                      if (!ffQaReducedMotion) {
                        live.classList.add('ff-qa-badge-pop');
                        setTimeout(function () { live.classList.remove('ff-qa-badge-pop'); }, 500);
                      }
                      return true;
                    }
                  }
                } catch (e) {}
                return false;
              }
              /* Small non-blocking confirmation toast — a single reusable element,
                 bottom-centre, auto-dismisses after ~2.5s, aria-live for SR users. */
              function ffQaToast(msg) {
                var t = document.getElementById('ff-qa-toast');
                if (!t) {
                  t = document.createElement('div');
                  t.id = 'ff-qa-toast';
                  t.className = 'ff-qa-toast';
                  t.setAttribute('role', 'status');
                  t.setAttribute('aria-live', 'polite');
                  document.body.appendChild(t);
                }
                t.textContent = msg;
                t.classList.remove('is-visible');
                void t.offsetWidth; /* restart the transition on rapid re-adds */
                t.classList.add('is-visible');
                if (window.__ffQaToastTimer) { clearTimeout(window.__ffQaToastTimer); }
                window.__ffQaToastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2500);
              }

              function ffQaAddToCart(btn) {
                var variantId = btn.getAttribute('data-variant-id');
                if (!variantId || btn.disabled || btn.classList.contains('is-loading')) { return; }
                var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
                btn.classList.add('is-loading');
                fetch(root + 'cart/add.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] , sections: 'cart-drawer,cart-icon-bubble' })
                })
                  .then(function (res) {
                    return res.json().then(function (data) { return { ok: res.ok, data: data }; });
                  })
                  .then(function (result) {
                    btn.classList.remove('is-loading');
                    if (!result.ok) {
                      btn.classList.add('is-error');
                      setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
                      return;
                    }
                    ffQaShowAdded(btn); /* icon press animation (squeeze-pop + check) */
                    /* close the options popover (if this add came from one) so the
                       card is clean behind the drawer */
                    var srcPanel = btn.closest('[data-ff-qa-panel]');
                    if (srcPanel) {
                      var srcRoot = ffQaRoot(btn);
                      ffQaClosePanel(srcPanel, srcRoot && srcRoot.querySelector('[data-ff-qa-toggle]'));
                    }
                    /* FF WAVE 6 (2026-08-13, wip170): TRUE — the drawer is the
                       confirmation on every add now, so arm cart-drawer.liquid's
                       safety-net listener instead of vetoing it. */
                    window.__ffLastAddIsHero = true;
                    var synced = ffQaSyncDrawer(result.data && result.data.sections);
                    var badged = ffQaSyncBadge(result.data && result.data.sections);
                    /* Only open directly when we actually swapped in fresh drawer HTML.
                       If the add response carried no cart-drawer section, leave the open
                       to the safety net below — it fetches its own fresh copy, so the
                       shopper can never be shown a stale drawer. */
                    if (synced) { ffQaOpenDrawer(); }
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'ff-quick-add' } }));
                    if (!badged) { ffQaRefreshCartBadge(); }
                    ffQaConfirmAdd();
                  })
                  .catch(function () {
                    btn.classList.remove('is-loading');
                  });
              }

              document.addEventListener('click', function (e) {
                /* FF FIX BATCH 2026-08-12 (item 3): explicit X close control */
                var closeBtn = e.target.closest('[data-ff-qa-close]');
                if (closeBtn) {
                  var cPanel = closeBtn.closest('[data-ff-qa-panel]');
                  var cRoot = ffQaRoot(closeBtn);
                  if (cPanel) { ffQaClosePanel(cPanel, cRoot && cRoot.querySelector('[data-ff-qa-toggle]')); }
                  return;
                }

                var toggleBtn = e.target.closest('[data-ff-qa-toggle]');
                if (toggleBtn) {
                  var root = ffQaRoot(toggleBtn);
                  var panel = root && root.querySelector('[data-ff-qa-panel]');
                  if (!panel) { return; }
                  if (panel.hidden) { ffQaOpenPanel(panel, toggleBtn); } else { ffQaClosePanel(panel, toggleBtn); }
                  return;
                }

                /* FF WAVE 4 (2026-08-12, popover redesign): piece-count bucket pills
                   filter the configuration rows below them — they are NOT option
                   selections themselves (not data-ff-qa-pill), so the variant-match
                   logic never sees them. Selecting a bucket hides non-matching rows
                   and deselects a now-hidden row so the add button can't keep a
                   stale variant. */
                var bucketBtn = e.target.closest('[data-ff-qa-bucket]');
                if (bucketBtn) {
                  var bGroup = bucketBtn.closest('[data-ff-qa-group]');
                  if (!bGroup) { return; }
                  var bPills = bGroup.querySelectorAll('[data-ff-qa-bucket]');
                  for (var b = 0; b < bPills.length; b++) { bPills[b].classList.remove('is-selected'); }
                  bucketBtn.classList.add('is-selected');
                  var bVal = bucketBtn.getAttribute('data-bucket');
                  var bRows = bGroup.querySelectorAll('[data-ff-qa-pill]');
                  for (var r = 0; r < bRows.length; r++) {
                    var show = bRows[r].getAttribute('data-bucket') === bVal;
                    bRows[r].classList.toggle('ff-qa-hidden', !show);
                    if (!show) { bRows[r].classList.remove('is-selected'); }
                  }
                  ffQaUpdatePanelState(ffQaRoot(bucketBtn));
                  return;
                }

                var pill = e.target.closest('[data-ff-qa-pill]');
                if (pill) {
                  var group = pill.closest('[data-ff-qa-group]');
                  /* FF WAVE 4: attribute selector — config rows share the data
                     attribute, not the '.ff-qa-pill' class. */
                  var siblings = group.querySelectorAll('[data-ff-qa-pill]');
                  for (var i = 0; i < siblings.length; i++) { siblings[i].classList.remove('is-selected'); }
                  pill.classList.add('is-selected');
                  ffQaUpdatePanelState(ffQaRoot(pill));
                  return;
                }

                var addBtn = e.target.closest('[data-ff-qa-add]');
                if (addBtn) {
                  ffQaAddToCart(addBtn);
                  return;
                }

                /* FF FIX BATCH 2026-08-12 (item 3): click anywhere OUTSIDE an open
                   popover (and not on its own controls, all handled above) closes it. */
                var openPanelEl = document.querySelector('[data-ff-qa-panel]:not([hidden])');
                if (openPanelEl && !e.target.closest('[data-ff-qa-panel]')) {
                  var opRoot = ffQaRoot(openPanelEl);
                  ffQaClosePanel(openPanelEl, opRoot && opRoot.querySelector('[data-ff-qa-toggle]'));
                }
              });

              document.addEventListener('keydown', function (e) {
                if (e.key !== 'Escape') { return; }
                var openPanelEl = document.querySelector('[data-ff-qa-panel]:not([hidden])');
                if (!openPanelEl) { return; }
                var root = ffQaRoot(openPanelEl);
                var toggleBtn = root && root.querySelector('[data-ff-qa-toggle]');
                ffQaClosePanel(openPanelEl, toggleBtn);
              });

              /* FF WAVE 7 (2026-08-13, item 2): hovering a C+ line colour dot
                 (.ff-cplus-dot, display-only until now) swaps the card's own image
                 to that colour, reverting on mouse-out. Real-hover devices only —
                 gated on matchMedia('(hover:hover) and (pointer:fine)') so a touch
                 tap never triggers it and never needs a second tap to "unstick" a
                 simulated hover (the dots have no click/tap behaviour of their own
                 either way, so a stray synthesized mouseenter on tap is harmless,
                 but the gate keeps touch devices out of this code path entirely).

                 PRECEDENCE, decided and documented here because two hover effects
                 would otherwise fight over the same <img>:
                 1) The quick-add POPOVER wins whenever it's open on this card —
                    hover-swap is a no-op while [data-ff-qa-panel] is not hidden, so
                    a stray hover on the (visually adjacent) closed-card dots can
                    never clobber an in-progress popover selection.
                 2) Otherwise, the SWATCH HOVER wins over the generic whole-card
                    hover-shows-2nd-image effect (template-collection.css, the
                    `.card-wrapper:hover .media img + img` rules). Both are
                    triggered by the same `.card-wrapper:hover`, since the C+ dots
                    sit inside the card wrapper — without an explicit tie-break the
                    2nd image would simply paint on top and hide the colour swap.
                    The .ff-cplus-swatch-hover class (added/removed here) forces
                    the 2nd image back to opacity:0 in CSS while a dot is hovered,
                    so the colour-accurate swap is what's actually visible. */
              function ffQaDotHoverEnabled() {
                return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
              }

              document.addEventListener('mouseenter', function (e) {
                var dot = e.target && e.target.closest && e.target.closest('.ff-cplus-dot[title]');
                if (!dot || !ffQaDotHoverEnabled()) { return; }
                var wrapper = dot.closest('.card-wrapper');
                var root = wrapper && wrapper.querySelector('[data-ff-qa-root]');
                if (!root) { return; }
                var openPanel = root.querySelector('[data-ff-qa-panel]:not([hidden])');
                if (openPanel) { return; }
                var img = wrapper.querySelector('.card__media img');
                if (!img) { return; }
                var url = ffQaFindColorVariantImage(root, dot.getAttribute('title'));
                if (!url) { return; }
                ffQaCaptureOriginalImage(img);
                ffQaApplySwappedImage(img, url);
                wrapper.classList.add('ff-cplus-swatch-hover');
              }, true);

              document.addEventListener('mouseleave', function (e) {
                var dot = e.target && e.target.closest && e.target.closest('.ff-cplus-dot[title]');
                if (!dot) { return; }
                var wrapper = dot.closest('.card-wrapper');
                if (!wrapper || !wrapper.classList.contains('ff-cplus-swatch-hover')) { return; }
                wrapper.classList.remove('ff-cplus-swatch-hover');
                var img = wrapper.querySelector('.card__media img');
                if (img) { ffQaRestoreOriginalImage(img); }
              }, true);
            })();
